module.exports = __webpack_public_path__ + "static/embossed-labels-f3da8356874ed88dbf478077656ea404.png";